import React, { useState } from 'react';
import {
  AppBar,
  Box,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { ReactComponent as DigitalTwinLogo } from '../graphics/svg/digital-twin-logo-icon.svg';

import UserMenu from './user/UserMenu';

/**
 * Header bar.
 * @returns {React.FunctionComponent} React element that contains the component.
 */
function Header() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const [anchorElUser, setAnchorElUser] = useState(null);

  return (
    <AppBar
      position="static"
      elevation={1}
      sx={{ bgcolor: 'background.paper', mb: '2px' }}
    >
      <Toolbar sx={{ px: '16px !important' }}>
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            onClick={() => navigate(`/${i18n.language}/home`)}
            sx={{ alignItems: 'center', justifyContent: 'flex-start' }}
          >
            <DigitalTwinLogo width={32} height={32} />
            <Typography variant="h5" color="primary" sx={{ cursor: 'default' }}>
              Digital Twin
            </Typography>
          </Stack>
          <Stack
            direction="row"
            sx={{ alignItems: 'center', justifyContent: 'flex-end' }}
          >
            <Box>
              <IconButton
                variant="contained"
                size="small"
                onClick={(e) => setAnchorElUser(e.currentTarget)}
              >
                <FontAwesomeIcon icon="user-circle" />
              </IconButton>
              <UserMenu
                anchorEl={anchorElUser}
                onClose={() => setAnchorElUser(null)}
              />
            </Box>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
